module.exports = __webpack_public_path__ + "static/media/basel-18.71529282.jpg";